import { AccountProfileUser } from './account-profile-user';
import { AccountSummary } from './account-summary';

export interface AccountProfile extends AccountSummary {
  users: AccountProfileUser[];
}
